"use client";

import { studioAssetPathnameFromPublicUrl } from "@/utils/studioBlobStorage";

export async function deleteStudioAssetFromClient(url: string): Promise<void> {
  const pathname = studioAssetPathnameFromPublicUrl(url);
  if (!pathname) {
    throw new Error("unsupported_asset_url");
  }

  const response = await fetch(
    `/api/studio/files/${pathname
      .split("/")
      .map((segment) => encodeURIComponent(segment))
      .join("/")}`,
    { method: "DELETE" },
  );

  const payload = (await response.json()) as { error?: string };
  if (!response.ok) {
    throw new Error(payload.error ?? "delete_failed");
  }
}
